/**
 * HLA Epitope Registry (EpRegistry) Reference Data
 * Source: www.epregistry.com.br / IHIW EpRegistry Standard
 * Contains canonical verified and theoretical eplets across Class I & Class II loci.
 */

// 1. Defined Eplet Catalog with Evidence, Locus, and 3D Exposition Scores
const EPLET_CATALOG = {
  // --- Class I: HLA-ABC Eplets ---
  "62GE": {
    id: "62GE",
    locus: "ABC",
    positions: [62, 63],
    residues: "GE",
    evidence: "Confirmed",
    exposition: 0.88,
    description: "Alpha-1 helix residue 62-63 accessible loop (Gly-Glu)",
    alleles: ["A*02:01", "A*02:02", "A*02:03", "A*02:06", "A*68:01", "A*69:01"],
  },
  "62GK": {
    id: "62GK",
    locus: "ABC",
    positions: [62, 63],
    residues: "GK",
    evidence: "Confirmed",
    exposition: 0.85,
    description: "Alpha-1 helix residue 62-63 (Gly-Lys)",
    alleles: ["A*24:02", "A*24:03", "A*23:01"],
  },
  "62QE": {
    id: "62QE",
    locus: "ABC",
    positions: [62, 63],
    residues: "QE",
    evidence: "Confirmed",
    exposition: 0.86,
    description: "Alpha-1 helix residue 62-63 (Gln-Glu)",
    alleles: ["A*01:01", "A*03:01", "A*11:01", "A*30:01", "A*31:01"],
  },
  "65RA": {
    id: "65RA",
    locus: "ABC",
    positions: [65, 66],
    residues: "RA",
    evidence: "Theoretical",
    exposition: 0.72,
    description: "Alpha-1 helix Arg65-Ala66",
    alleles: ["A*01:01", "A*03:01", "A*11:01", "B*08:01"],
  },
  "65GK": {
    id: "65GK",
    locus: "ABC",
    positions: [65, 66],
    residues: "GK",
    evidence: "Confirmed",
    exposition: 0.76,
    description: "Alpha-1 helix Gly65-Lys66",
    alleles: ["A*02:01", "A*02:06", "A*24:02"],
  },
  "82LR": {
    id: "82LR",
    locus: "ABC",
    positions: [82, 83],
    residues: "LR",
    evidence: "Confirmed",
    exposition: 0.91,
    description: "Alpha-1 helix C-terminal Leu82-Arg83 public motif",
    alleles: ["B*07:02", "B*08:01", "B*27:05", "B*40:01", "B*44:02", "B*44:03"],
  },
  "144TKH": {
    id: "144TKH",
    locus: "ABC",
    positions: [144, 145, 151],
    residues: "TKH",
    evidence: "Confirmed",
    exposition: 0.94,
    description: "Alpha-2 helix loop Thr144-Lys145-His151 (Broad Bw4-related specificity)",
    alleles: ["A*23:01", "A*24:03", "A*25:01", "A*32:01"],
  },
  "144KR": {
    id: "144KR",
    locus: "ABC",
    positions: [144, 145],
    residues: "KR",
    evidence: "Confirmed",
    exposition: 0.89,
    description: "Alpha-2 helix Lys144-Arg145 motif",
    alleles: ["A*02:01", "A*24:02", "A*68:01", "A*69:01"],
  },
  "163RW": {
    id: "163RW",
    locus: "ABC",
    positions: [163, 167],
    residues: "RW",
    evidence: "Confirmed",
    exposition: 0.92,
    description: "Alpha-2 helix surface Arg163-Trp167 prominent ridge",
    alleles: ["B*07:02", "B*27:05", "B*15:01", "B*35:01", "B*51:01"],
  },
  "163LW": {
    id: "163LW",
    locus: "ABC",
    positions: [163, 167],
    residues: "LW",
    evidence: "Confirmed",
    exposition: 0.90,
    description: "Alpha-2 helix Leu163-Trp167",
    alleles: ["B*08:01", "B*44:02", "B*44:03", "B*40:01"],
  },
  "156DA": {
    id: "156DA",
    locus: "ABC",
    positions: [156, 158],
    residues: "DA",
    evidence: "Confirmed",
    exposition: 0.83,
    description: "Alpha-2 helix Asp156-Ala158 (Distinctive B*44:02 marker)",
    alleles: ["B*44:02", "B*08:01"],
  },
  "156LA": {
    id: "156LA",
    locus: "ABC",
    positions: [156, 158],
    residues: "LA",
    evidence: "Confirmed",
    exposition: 0.79,
    description: "Alpha-2 helix Leu156-Ala158 (Distinctive B*44:03 marker)",
    alleles: ["B*44:03"],
  },
  "177DK": {
    id: "177DK",
    locus: "ABC",
    positions: [177, 178],
    residues: "DK",
    evidence: "Theoretical",
    exposition: 0.74,
    description: "Alpha-2 helix terminal Asp177-Lys178",
    alleles: ["C*07:01", "C*07:02", "C*03:04", "C*04:01", "C*06:02"],
  },
  "99FY": {
    id: "99FY",
    locus: "ABC",
    positions: [99, 100],
    residues: "FY",
    evidence: "Confirmed",
    exposition: 0.81,
    description: "Beta-pleated sheet floor Phe99-Tyr100",
    alleles: ["C*03:04", "C*07:01", "C*07:02"],
  },
  "193PL": {
    id: "193PL",
    locus: "ABC",
    positions: [193, 194],
    residues: "PL",
    evidence: "Theoretical",
    exposition: 0.69,
    description: "Alpha-3 domain Pro193-Leu194",
    alleles: ["C*04:01", "C*06:02"],
  },

  // --- Class II: HLA-DRB1/3/4/5 Eplets ---
  "70Q": {
    id: "70Q",
    locus: "DRB",
    positions: [70],
    residues: "Q",
    evidence: "Confirmed",
    exposition: 0.95,
    description: "DRB1 beta-1 domain hypervariable region Gln70 (Shared epitope marker)",
    alleles: ["DRB1*04:01", "DRB1*04:04", "DRB1*01:01"],
  },
  "70D": {
    id: "70D",
    locus: "DRB",
    positions: [70],
    residues: "D",
    evidence: "Confirmed",
    exposition: 0.94,
    description: "DRB1 beta-1 domain Asp70",
    alleles: ["DRB1*03:01", "DRB1*11:01", "DRB1*13:01"],
  },
  "70R": {
    id: "70R",
    locus: "DRB",
    positions: [70],
    residues: "R",
    evidence: "Confirmed",
    exposition: 0.96,
    description: "DRB1 beta-1 domain Arg70",
    alleles: ["DRB1*15:01", "DRB1*15:02", "DRB1*16:01"],
  },
  "86V": {
    id: "86V",
    locus: "DRB",
    positions: [86],
    residues: "V",
    evidence: "Confirmed",
    exposition: 0.88,
    description: "DRB1 Val86 deep pocket peptide binding rim",
    alleles: ["DRB1*04:01", "DRB1*15:01", "DRB1*07:01"],
  },
  "86G": {
    id: "86G",
    locus: "DRB",
    positions: [86],
    residues: "G",
    evidence: "Confirmed",
    exposition: 0.87,
    description: "DRB1 Gly86 pocket rim substitution",
    alleles: ["DRB1*03:01", "DRB1*11:01", "DRB1*13:01", "DRB1*04:04"],
  },
  "96EV": {
    id: "96EV",
    locus: "DRB",
    positions: [96, 98],
    residues: "EV",
    evidence: "Confirmed",
    exposition: 0.89,
    description: "DRB1 loop Glu96-Val98",
    alleles: ["DRB1*07:01", "DRB1*09:01"],
  },
  "140ST": {
    id: "140ST",
    locus: "DRB",
    positions: [140, 142],
    residues: "ST",
    evidence: "Theoretical",
    exposition: 0.75,
    description: "DRB1 beta-2 domain Ser140-Thr142",
    alleles: ["DRB1*15:01", "DRB1*07:01", "DRB1*11:01"],
  },

  // --- Class II: HLA-DQB1/DQA1 Eplets ---
  "52PQ": {
    id: "52PQ",
    locus: "DQ",
    positions: [52, 53],
    residues: "PQ",
    evidence: "Confirmed",
    exposition: 0.96,
    description: "DQB1 beta-chain loop Pro52-Gln53 (Primary target for de novo DQ-DSA)",
    alleles: ["DQB1*03:01", "DQB1*03:02", "DQB1*03:03"],
  },
  "52PR": {
    id: "52PR",
    locus: "DQ",
    positions: [52, 53],
    residues: "PR",
    evidence: "Confirmed",
    exposition: 0.94,
    description: "DQB1 Pro52-Arg53",
    alleles: ["DQB1*02:01", "DQB1*02:02"],
  },
  "52PL": {
    id: "52PL",
    locus: "DQ",
    positions: [52, 53],
    residues: "PL",
    evidence: "Confirmed",
    exposition: 0.93,
    description: "DQB1 Pro52-Leu53",
    alleles: ["DQB1*06:01", "DQB1*06:02", "DQB1*05:01"],
  },
  "45GE": {
    id: "45GE",
    locus: "DQ",
    positions: [45, 46],
    residues: "GE",
    evidence: "Confirmed",
    exposition: 0.91,
    description: "DQB1 Gly45-Glu46 outer loop",
    alleles: ["DQB1*02:01", "DQB1*02:02", "DQB1*03:02"],
  },
  "45EV": {
    id: "45EV",
    locus: "DQ",
    positions: [45, 47],
    residues: "EV",
    evidence: "Confirmed",
    exposition: 0.89,
    description: "DQB1 Glu45-Val47",
    alleles: ["DQB1*03:01", "DQB1*06:01", "DQB1*05:01"],
  },
  "160LE": {
    id: "160LE",
    locus: "DQ",
    positions: [160, 161],
    residues: "LE",
    evidence: "Theoretical",
    exposition: 0.78,
    description: "DQB1 beta-2 domain Leu160-Glu161",
    alleles: ["DQB1*03:01", "DQB1*02:01", "DQB1*06:01"],
  },

  // --- Class II: HLA-DPB1 Eplets ---
  "84DEAV": {
    id: "84DEAV",
    locus: "DP",
    positions: [84, 85, 86, 87],
    residues: "DEAV",
    evidence: "Confirmed",
    exposition: 0.95,
    description: "DPB1 beta-1 domain hypervariable region Asp84-Glu85-Ala86-Val87",
    alleles: ["DPB1*02:01", "DPB1*04:01", "DPB1*04:02"],
  },
  "84GG": {
    id: "84GG",
    locus: "DP",
    positions: [84, 85],
    residues: "GG",
    evidence: "Confirmed",
    exposition: 0.93,
    description: "DPB1 Gly84-Gly85 substitution",
    alleles: ["DPB1*05:01", "DPB1*03:01"],
  },
  "35FV": {
    id: "35FV",
    locus: "DP",
    positions: [35, 36],
    residues: "FV",
    evidence: "Confirmed",
    exposition: 0.87,
    description: "DPB1 Phe35-Val36 outer beta sheet",
    alleles: ["DPB1*04:01", "DPB1*04:02", "DPB1*05:01"],
  },
  "35LL": {
    id: "35LL",
    locus: "DP",
    positions: [35, 36],
    residues: "LL",
    evidence: "Theoretical",
    exposition: 0.84,
    description: "DPB1 Leu35-Leu36",
    alleles: ["DPB1*02:01", "DPB1*03:01"],
  },
};

// 2. Population Frequency-Based 2-Digit to High-Resolution Imputation Map
// Bridges conventional serology typing to standard 4-digit alleles
const IMPUTATION_MAP = {
  // HLA-A
  "A*01": "A*01:01", "A*1": "A*01:01", "A1": "A*01:01",
  "A*02": "A*02:01", "A*2": "A*02:01", "A2": "A*02:01",
  "A*03": "A*03:01", "A*3": "A*03:01", "A3": "A*03:01",
  "A*11": "A*11:01", "A11": "A*11:01",
  "A*23": "A*23:01", "A23": "A*23:01",
  "A*24": "A*24:02", "A24": "A*24:02",
  "A*30": "A*30:01", "A30": "A*30:01",
  "A*31": "A*31:01", "A31": "A*31:01",
  "A*68": "A*68:01", "A68": "A*68:01",
  // HLA-B
  "B*07": "B*07:02", "B*7": "B*07:02", "B7": "B*07:02",
  "B*08": "B*08:01", "B*8": "B*08:01", "B8": "B*08:01",
  "B*15": "B*15:01", "B15": "B*15:01",
  "B*27": "B*27:05", "B27": "B*27:05",
  "B*35": "B*35:01", "B35": "B*35:01",
  "B*40": "B*40:01", "B40": "B*40:01",
  "B*44": "B*44:02", "B44": "B*44:02",
  "B*51": "B*51:01", "B51": "B*51:01",
  // HLA-C
  "C*03": "C*03:04", "C3": "C*03:04",
  "C*04": "C*04:01", "C4": "C*04:01",
  "C*06": "C*06:02", "C6": "C*06:02",
  "C*07": "C*07:01", "C7": "C*07:01",
  // HLA-DRB1
  "DRB1*01": "DRB1*01:01", "DR1": "DRB1*01:01",
  "DRB1*03": "DRB1*03:01", "DR3": "DRB1*03:01",
  "DRB1*04": "DRB1*04:01", "DR4": "DRB1*04:01",
  "DRB1*07": "DRB1*07:01", "DR7": "DRB1*07:01",
  "DRB1*11": "DRB1*11:01", "DR11": "DRB1*11:01",
  "DRB1*13": "DRB1*13:01", "DR13": "DRB1*13:01",
  "DRB1*15": "DRB1*15:01", "DR15": "DRB1*15:01", "DR2": "DRB1*15:01",
  // HLA-DQB1
  "DQB1*02": "DQB1*02:01", "DQ2": "DQB1*02:01",
  "DQB1*03": "DQB1*03:01", "DQ3": "DQB1*03:01",
  "DQB1*05": "DQB1*05:01", "DQ5": "DQB1*05:01", "DQ1": "DQB1*05:01",
  "DQB1*06": "DQB1*06:01", "DQ6": "DQB1*06:01",
  // HLA-DPB1
  "DPB1*02": "DPB1*02:01", "DP2": "DPB1*02:01",
  "DPB1*03": "DPB1*03:01", "DP3": "DPB1*03:01",
  "DPB1*04": "DPB1*04:01", "DP4": "DPB1*04:01",
  "DPB1*05": "DPB1*05:01", "DP5": "DPB1*05:01",
};

// 3. Fast Inverted Index: Allele -> Eplet IDs
const buildAlleleEpletMap = () => {
  const map = {};
  for (const [epletId, eplet] of Object.entries(EPLET_CATALOG)) {
    for (const allele of eplet.alleles) {
      if (!map[allele]) map[allele] = [];
      map[allele].push(epletId);
    }
  }
  return map;
};

const ALLELE_EPLET_MAP = buildAlleleEpletMap();

module.exports = {
  EPLET_CATALOG,
  IMPUTATION_MAP,
  ALLELE_EPLET_MAP,
};
